import React from "react";
import { Star, ExternalLink } from "lucide-react";

export const GoogleReviewsSection = ({ reviews = { rating: 4.8, user_ratings_total: 88, url: "" }, content }) => {
  const cfg = content?.testimonials || { cta_leave_review: "Voir tous les avis" };
  const rating = reviews.rating;
  const reviewCount = reviews.user_ratings_total;
  // Use the live cid URL from the API when available, with a stable fallback
  const googleBusinessUrl = reviews.url || "https://www.google.com/maps/search/Auvergne+Tech+Racing+Clermont-Ferrand";

  return (
    <section className="py-16 px-4 bg-[#0A0A0A]">
      <div className="max-w-4xl mx-auto">
        <a
          href={googleBusinessUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-link"
          className="block group"
        >
          <div className="bg-[#121212] border border-white/10 rounded-lg p-8 transition-all duration-300 hover:border-[#FF3B30]/50 hover:shadow-[0_0_30px_rgba(255,59,48,0.15)]">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              {/* Left: Google Logo & Rating */}
              <div className="flex items-center gap-6">
                {/* Google "G" Logo */}
                <div className="flex-shrink-0">
                  <svg viewBox="0 0 24 24" className="w-12 h-12" aria-label="Google">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                </div>

                {/* Rating Info */}
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-4xl font-bold text-white">{rating}</span>
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={20}
                          className={
                            i < Math.floor(rating)
                              ? "text-yellow-400 fill-yellow-400"
                              : i < rating
                              ? "text-yellow-400 fill-yellow-400 opacity-50"
                              : "text-white/20"
                          }
                        />
                      ))}
                    </div>
                  </div>
                  <p className="text-white/60 text-sm">
                    Basé sur <span className="text-white font-semibold">{reviewCount} avis</span> Google
                  </p>
                </div>
              </div>

              {/* Right: CTA */}
              <div className="flex items-center gap-3 text-[#FF3B30] group-hover:text-white transition-colors">
                <span className="font-semibold text-sm uppercase tracking-wider">
                  {cfg.cta_leave_review || "Voir tous les avis"}
                </span>
                <ExternalLink size={18} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

// ============== TESTIMONIALS SECTION ==============
